// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"b4f1e842","84":"4f03c794","953":"78f1063a"}[chunkId] + ".chunk.css";
};